<template>
  <div class="row">
    <template v-if="storefront.integrationSystem == 'ShipStationV2' || storefront.integrationSystem == 'ShipStationDirectV1'">
      <input type="text" style="display:none" autocomplete="username" />
      <input type="password" style="display:none" autocomplete="new-password" />
      <b-form-group class="col-6" label="ShipStation API Key:">
        <b-form-input
          id="form-input-apiKey"
          v-model="storefront.shipStationApiKey"
          v-validate="{ required: true }"
          name="form-input-apiKey"
          :state="validateState('form-input-apiKey')"
          data-vv-as="API Key"
          type="password"
          autocomplete="new-password"
              />
        <b-form-invalid-feedback id="form-input-apiKey-feedback">
          {{ veeErrors.first('form-input-apiKey') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="ShipStation API Secret:">
        <b-form-input
          id="form-input-apiSecret"
          v-model="storefront.shipStationApiSecret"
          v-validate="{ required: true }"
          name="form-input-apiSecret"
          :state="validateState('form-input-apiSecret')"
          data-vv-as="API Secret"
          type="password"
          autocomplete="new-password"
              />
        <b-form-invalid-feedback id="form-input-apiSecret-feedback">
          {{ veeErrors.first('form-input-apiSecret') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-12" label="Sync only Orders for Order Group:">
        <b-v-select
          v-model="storefront.onlySyncStoreId"
          v-validate="{ required: false }"
          :searchable="true"
          name="form-input-onlySyncStoreId"
          :state="validateState('form-input-onlySyncStoreId')"
          data-vv-as="ShipStation Store"
          :options="storesListPosBySSId"
        >
          <template v-slot:validationMsg>
            <b-form-invalid-feedback
              :id="'form-input-onlySyncStoreId-feedback'"
            >
              {{ veeErrors.first('form-input-onlySyncStoreId') }}
            </b-form-invalid-feedback>
          </template>
        </b-v-select>
      </b-form-group>
      <b-form-group class="col-12" label="Sync only Orders for ShipStation User:">
        <b-v-select
          v-model="storefront.onlyFulfillShipStationUserId"
          v-validate="{ required: false }"
          :searchable="true"
          name="form-input-onlyFulfillShipStationUserId"
          :state="validateState('form-input-onlyFulfillShipStationUserId')"
          data-vv-as="ShipStation User"
          :options="ssAccountUsersList"
        >
          <template v-slot:validationMsg>
            <b-form-invalid-feedback
              :id="'form-input-onlyFulfillShipStationUserId-feedback'"
            >
              {{ veeErrors.first('form-input-onlyFulfillShipStationUserId') }}
            </b-form-invalid-feedback>
          </template>
        </b-v-select>
      </b-form-group>
    </template>
    <template v-else-if="storefront.integrationSystem == 'WooCommerceDirect'">
      <input type="text" style="display:none" autocomplete="username" />
      <input type="password" style="display:none" autocomplete="new-password" />
      <b-form-group class="col-6" label="WooCommerce Consumer Key:">
        <b-form-input
          id="form-input-wooCommerceConsumerKey"
          v-model="storefront.wooCommerceConsumerKey"
          v-validate="{ required: true }"
          name="form-input-wooCommerceConsumerKey"
          :state="validateState('form-input-wooCommerceConsumerKey')"
          data-vv-as="WooCommerce Consumer Key"
          autocomplete="off"
              />
        <b-form-invalid-feedback id="form-input-wooCommerceConsumerKey-feedback">
          {{ veeErrors.first('form-input-wooCommerceConsumerKey') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="WooCommerce Consumer Secret:">
        <b-form-input
          id="form-input-wooCommerceConsumerSecret"
          v-model="storefront.wooCommerceConsumerSecret"
          v-validate="{ required: true }"
          name="form-input-wooCommerceConsumerSecret"
          :state="validateState('form-input-wooCommerceConsumerSecret')"
          data-vv-as="WooCommerce Consumer Secret"
          autocomplete="new-password"
              />
        <b-form-invalid-feedback id="form-input-wooCommerceConsumerSecret-feedback">
          {{ veeErrors.first('form-input-wooCommerceConsumerSecret') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="WooCommerce Domain:">
        <b-form-input
          id="form-input-wooCommerceDomain"
          v-model="storefront.wooCommerceDomain"
          v-validate="{ required: true }"
          name="form-input-wooCommerceDomain"
          :state="validateState('form-input-wooCommerceDomain')"
          data-vv-as="WooCommerce Domain"
              />
        <b-form-invalid-feedback id="form-input-wooCommerceDomain-feedback">
          {{ veeErrors.first('form-input-wooCommerceDomain') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="Order Number Prefix:">
        <b-form-input
          id="form-input-orderNumberPrefix"
          v-model="storefront.orderNumberPrefix"
          v-validate="{ required: false }"
          name="form-input-orderNumberPrefix"
          :state="validateState('form-input-orderNumberPrefix')"
          data-vv-as="Order Number Prefix"
              />
        <b-form-invalid-feedback id="form-input-wooCommerceDomain-feedback">
          {{ veeErrors.first('form-input-wooCommerceDomain') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </template>
    <template v-else-if="storefront.integrationSystem == 'CartRoverThirdParty'">
      <input type="text" style="display:none" autocomplete="username" />
      <input type="password" style="display:none" autocomplete="new-password" />
      <b-form-group class="col-6" label="CartRover API User:">
        <b-form-input
          id="form-input-cartRoverApiKey"
          v-model="storefront.cartRoverApiKey"
          v-validate="{ required: true }"
          name="form-input-cartRoverApiKey"
          :state="validateState('form-input-cartRoverApiKey')"
          data-vv-as="CartRover API User"
          autocomplete="off"
              />
        <b-form-invalid-feedback id="form-input-cartRoverApiKey-feedback">
          {{ veeErrors.first('form-input-cartRoverApiKey') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="CartRover API Key:">
        <b-form-input
          id="form-input-cartRoverApiSecret"
          v-model="storefront.cartRoverApiSecret"
          v-validate="{ required: true }"
          name="form-input-cartRoverApiSecret"
          :state="validateState('form-input-cartRoverApiSecret')"
          data-vv-as="CartRover API Key"
          autocomplete="new-password"
              />
        <b-form-invalid-feedback id="form-input-cartRoverApiSecret-feedback">
          {{ veeErrors.first('form-input-cartRoverApiSecret') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="CartRover Order Source ID (optional):">
        <b-form-input
          id="form-input-cartRoverOrderSource"
          v-model="storefront.cartRoverOrderSource"
          v-validate="{ required: false }"
          name="form-input-cartRoverOrderSource"
          :state="validateState('form-input-cartRoverOrderSource')"
          data-vv-as="CartRover Order Source ID"
              />
        <b-form-invalid-feedback id="form-input-cartRoverOrderSource-feedback">
          {{ veeErrors.first('form-input-cartRoverOrderSource') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </template>
    <template v-else-if="storefront.integrationSystem == 'ShopifyDirect' || storefront.integrationSystem == 'ShopifyDirect_Simple'">
     <div v-if="storefront.integrationValid" class="col-12">
        <b-alert show variant="success">Your shopify store is connected!
          <span v-if="storefront.integrationSystem == 'ShopifyDirect_Simple'">A new fulfillment service, and location should be available on your store.</span>
        </b-alert>
      </div>
      <div v-else>
        <b-alert show variant="info">To connect your shopify store with this Connect Storefront, you will first need to add the LaCore Connect Shopify app to your store.</b-alert>
      </div>
      <b-form-group class="col-6" label="Shopify CustomApp Client Id:" v-if="is('developer')">
        <b-form-input
          id="form-input-shopifyAppClientId"
          v-model="storefront.shopifyAppClientId"
          v-validate="{ required: false }"
          name="form-input-shopifyAppClientId"
          :state="validateState('form-input-shopifyAppClientId')"
              />
        <b-form-invalid-feedback id="form-input-shopifyAppClientId-feedback">
          {{ veeErrors.first('form-input-shopifyAppClientId') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="Shopify CustomApp Client Secret:" v-if="is('developer')">
        <b-form-input
          id="form-input-shopifyAppClientSecret"
          v-model="storefront.shopifyAppClientSecret"
          v-validate="{ required: false }"
          name="form-input-shopifyAppClientSecret"
          :state="validateState('form-input-shopifyAppClientSecret')"
              />
        <b-form-invalid-feedback id="form-input-shopifyAppClientSecret-feedback">
          {{ veeErrors.first('form-input-shopifyAppClientSecret') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="Storefront ID:">
        <b-input-group>
          <b-form-input
            id="form-input-storefrontId"
            :value="storefront.id"
            readonly
            disabled
          />
          <b-input-group-append>
            <b-button variant="outline-secondary" @click="copyToClipboard(storefront.id)">
              <i class="fa fa-copy"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group class="col-6" label="Shopify Store Domain:">
        <b-form-input
          id="form-input-shopifyStoreDomain"
          v-model="storefront.shopifyStoreDomain"
          v-validate="{ required: false }"
          name="form-input-shopifyStoreDomain"
          :state="validateState('form-input-shopifyStoreDomain')"
              />
        <b-form-invalid-feedback id="form-input-shopifyStoreDomain-feedback">
          {{ veeErrors.first('form-input-shopifyStoreDomain') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="col-12 border-top pt-1 mt-1" v-if="is('brand-user')">
        <b-button size="md" v-if="storefront.shopifyStoreDomain && storefront.shopifyAppClientSecret && !storefront.integrationValid  && (storefront.integrationStatus == 'Active' || storefront.integrationStatus == 'PendingClientAction')" :variant="(storefront.integrationStatus == 'Active' ? 'warning' : 'info')" @click="AuthWithShopify()"><i class="fa fa-usb mr-1"></i> <span v-if="storefront.integrationStatus == 'Active'">RE-</span>Auth with Shopify</b-button>
        <b-button size="md" class="ml-2" variant="danger"  @click="RemoveAuthWithShopify()" v-if="storefront.integrationValid && storefront.integrationStatus == 'Active'"><i class="fa fa-usb mr-1"></i> Remove Connection</b-button>
        <b-button size="md" class="ml-2" variant="info" @click="AuthWithShopify()" v-if="storefront.integrationValid && storefront.integrationStatus == 'Active'"><i class="fa fa-usb mr-1"></i> Re-Authorize Connection</b-button>
      </div>
    </template>
    <template v-else-if="storefront.integrationSystem == 'BigCommerce_Direct_StoreAPI'">
      <b-form-group class="col-6" label="BigCommerce Store Domain:">
        <b-form-input
          id="form-input-bigCommerceStoreDomain"
          v-model="storefront.bigCommerceStoreDomain"
          v-validate="{ required: true }"
          name="form-input-bigCommerceStoreDomain"
          :state="validateState('form-input-bigCommerceStoreDomain')"
          data-vv-as="BigCommerce Store Domain"
          placeholder="store-xyz123.mybigcommerce.com"
              />
        <b-form-invalid-feedback id="form-input-bigCommerceStoreDomain-feedback">
          {{ veeErrors.first('form-input-bigCommerceStoreDomain') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="BigCommerce API Base URL:">
        <b-form-input
          id="form-input-bigCommerceApiBase"
          v-model="storefront.bigCommerceApiBase"
          v-validate="{ required: true }"
          name="form-input-bigCommerceApiBase"
          :state="validateState('form-input-bigCommerceApiBase')"
          data-vv-as="BigCommerce API Base"
          placeholder="https://api.bigcommerce.com/stores/xyz123/v3"
              />
        <b-form-invalid-feedback id="form-input-bigCommerceApiBase-feedback">
          {{ veeErrors.first('form-input-bigCommerceApiBase') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-12" label="BigCommerce Access Token:">
        <b-form-input
          id="form-input-bigCommerceAccessToken"
          v-model="storefront.bigCommerceAccessToken"
          v-validate="{ required: true }"
          name="form-input-bigCommerceAccessToken"
          :state="validateState('form-input-bigCommerceAccessToken')"
          data-vv-as="BigCommerce Access Token"
          type="password"
              autocomplete="off"
              />
        <b-form-invalid-feedback id="form-input-bigCommerceAccessToken-feedback">
          {{ veeErrors.first('form-input-bigCommerceAccessToken') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="BigCommerce App Client ID:" v-if="is('developer')">
        <b-form-input
          id="form-input-bigCommerceAppClientId"
          v-model="storefront.bigCommerceAppClientId"
          v-validate="{ required: true }"
          name="form-input-bigCommerceAppClientId"
          :state="validateState('form-input-bigCommerceAppClientId')"
          data-vv-as="BigCommerce App Client ID"
              />
        <b-form-invalid-feedback id="form-input-bigCommerceAppClientId-feedback">
          {{ veeErrors.first('form-input-bigCommerceAppClientId') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="BigCommerce App Client Secret:" v-if="is('developer')">
        <b-form-input
          id="form-input-bigCommerceAppClientSecret"
          v-model="storefront.bigCommerceAppClientSecret"
          v-validate="{ required: true }"
          name="form-input-bigCommerceAppClientSecret"
          :state="validateState('form-input-bigCommerceAppClientSecret')"
          data-vv-as="BigCommerce App Client Secret"
          type="password"
              autocomplete="off"
              />
        <b-form-invalid-feedback id="form-input-bigCommerceAppClientSecret-feedback">
          {{ veeErrors.first('form-input-bigCommerceAppClientSecret') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </template>
    <template v-else-if="storefront.integrationSystem == 'BrightPearl'">
      <div v-if="storefront.integrationValid" class="col-12">
        <b-alert show variant="success">Your BrightPearl account is connected!</b-alert>
      </div>
      <div v-else class="col-12">
        <b-alert show variant="info">Enter your BrightPearl Account ID below, then click Connect to authorise via OAuth.</b-alert>
      </div>
      <b-form-group class="col-6" label="BrightPearl Account ID:">
        <b-form-input
          id="form-input-brightPearlAccountId"
          v-model="storefront.brightPearlAccountId"
          v-validate="{ required: true }"
          name="form-input-brightPearlAccountId"
          :state="validateState('form-input-brightPearlAccountId')"
          data-vv-as="BrightPearl Account ID"
          placeholder="your-account"
          :disabled="storefront.integrationValid"
        />
        <b-form-invalid-feedback id="form-input-brightPearlAccountId-feedback">
          {{ veeErrors.first('form-input-brightPearlAccountId') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="Order Number Prefix:">
        <b-form-input
          id="form-input-brightPearlOrderNumberPrefix"
          v-model="storefront.orderNumberPrefix"
          v-validate="{ required: false }"
          name="form-input-brightPearlOrderNumberPrefix"
          :state="validateState('form-input-brightPearlOrderNumberPrefix')"
          data-vv-as="Order Number Prefix"
        />
        <b-form-invalid-feedback id="form-input-brightPearlOrderNumberPrefix-feedback">
          {{ veeErrors.first('form-input-brightPearlOrderNumberPrefix') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <template v-if="storefront.integrationValid">
        <b-form-group class="col-6" label="BrightPearl Warehouse:">
          <b-v-select
            v-model="storefront.brightPearlWarehouseId"
            v-validate="{ required: true }"
            :searchable="true"
            name="form-input-brightPearlWarehouseId"
            :state="validateState('form-input-brightPearlWarehouseId')"
            data-vv-as="BrightPearl Warehouse"
            :options="brightPearlWarehouseOptions"
          >
            <template v-slot:validationMsg>
              <b-form-invalid-feedback id="form-input-brightPearlWarehouseId-feedback">
                {{ veeErrors.first('form-input-brightPearlWarehouseId') }}
              </b-form-invalid-feedback>
            </template>
          </b-v-select>
        </b-form-group>
        <b-form-group class="col-6" label="Filter by Order Status:">
          <b-v-select
            v-model="storefront.brightPearlOrderStatusIdFilter"
            v-validate="{ required: false }"
            :searchable="true"
            name="form-input-brightPearlOrderStatusIdFilter"
            :state="validateState('form-input-brightPearlOrderStatusIdFilter')"
            data-vv-as="Order Status Filter"
            :options="brightPearlOrderStatusMustHaveOptions"
          >
            <template v-slot:validationMsg>
              <b-form-invalid-feedback id="form-input-brightPearlOrderStatusIdFilter-feedback">
                {{ veeErrors.first('form-input-brightPearlOrderStatusIdFilter') }}
              </b-form-invalid-feedback>
            </template>
          </b-v-select>
        </b-form-group>
        <b-form-group class="col-6" label="Order Status Update - When Imported:">
          <b-v-select
            v-model="storefront.brightPearlOrderStatusAfterCreation"
            v-validate="{ required: true }"
            :searchable="true"
            name="form-input-brightPearlOrderStatusAfterCreation"
            :state="validateState('form-input-brightPearlOrderStatusAfterCreation')"
            data-vv-as="Order Status Filter"
            :options="brightPearlOrderStatusMustHaveOptions"
          >
            <template v-slot:validationMsg>
              <b-form-invalid-feedback id="form-input-brightPearlOrderStatusAfterCreation-feedback">
                {{ veeErrors.first('form-input-brightPearlOrderStatusAfterCreation') }}
              </b-form-invalid-feedback>
            </template>
          </b-v-select>
        </b-form-group>
        <b-form-group class="col-6" label="Order Status Update - When Shipped:">
          <b-v-select
            v-model="storefront.brightPearlOrderStatusIdAfterShipped"
            v-validate="{ required: true }"
            :searchable="true"
            name="form-input-brightPearlOrderStatusIdAfterShipped"
            :state="validateState('form-input-brightPearlOrderStatusIdAfterShipped')"
            data-vv-as="Order Status Filter"
            :options="brightPearlOrderStatusMustHaveOptions"
          >
            <template v-slot:validationMsg>
              <b-form-invalid-feedback id="form-input-brightPearlOrderStatusIdAfterShipped-feedback">
                {{ veeErrors.first('form-input-brightPearlOrderStatusIdAfterShipped') }}
              </b-form-invalid-feedback>
            </template>
          </b-v-select>
        </b-form-group>
        <b-form-group class="col-6" label="BrightPearl Contact (for Shipment Events):">
          <b-v-select
            v-model="storefront.brightPearlContactId"
            v-validate="{ required: false }"
            :searchable="true"
            name="form-input-brightPearlContactId"
            :state="validateState('form-input-brightPearlContactId')"
            data-vv-as="BrightPearl Contact"
            :options="brightPearlContactOptions"
          >
            <template v-slot:validationMsg>
              <b-form-invalid-feedback id="form-input-brightPearlContactId-feedback">
                {{ veeErrors.first('form-input-brightPearlContactId') }}
              </b-form-invalid-feedback>
            </template>
          </b-v-select>
        </b-form-group>
      </template>
      <div class="col-12 border-top pt-2 mt-1" v-if="is('brand-user')">
        <b-button
          size="md"
          variant="primary"
          :disabled="!storefront.brightPearlAccountId"
          @click="AuthWithBrightPearl()"
        >
          <i class="fa fa-plug mr-1"></i>
          <span v-if="storefront.integrationValid">Re-Connect BrightPearl</span>
          <span v-else>Connect BrightPearl</span>
        </b-button>
        <b-button
          size="md"
          class="ml-2"
          variant="danger"
          v-if="storefront.integrationValid"
          @click="RemoveAuthWithBrightPearl()"
        >
          <i class="fa fa-unlink mr-1"></i> Remove Connection
        </b-button>
      </div>
    </template>
    <template v-else-if="storefront.integrationSystem == 'Manual'">
      <div class="col-12">
        <b-alert show variant="info">Open a Ticket, for generating an API key for this client, if they don't already have one.</b-alert>
      </div>
    </template>
    <template v-else-if="storefront.integrationSystem == 'FtpImport'">
      <input type="text" style="display:none" autocomplete="username" />
      <input type="password" style="display:none" autocomplete="new-password" />
      <b-form-group class="col-6" label="SFTP Server:">
        <b-form-input
          id="form-input-ftpServer"
          v-model="storefront.ftpServer"
          v-validate="{ required: true }"
          name="form-input-ftpServer"
          :state="validateState('form-input-ftpServer')"
          data-vv-as="SFTP Server"
          placeholder="sftp.example.com"
          autocomplete="off"
        />
        <b-form-invalid-feedback id="form-input-ftpServer-feedback">
          {{ veeErrors.first('form-input-ftpServer') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="SFTP Port:">
        <b-form-input
          id="form-input-ftpPort"
          v-model.number="storefront.ftpPort"
          v-validate="{ required: true }"
          name="form-input-ftpPort"
          :state="validateState('form-input-ftpPort')"
          data-vv-as="SFTP Port"
          type="number"
          placeholder="2222"
        />
        <b-form-invalid-feedback id="form-input-ftpPort-feedback">
          {{ veeErrors.first('form-input-ftpPort') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="SFTP Username:">
        <b-form-input
          id="form-input-ftpUsername"
          v-model="storefront.ftpUsername"
          v-validate="{ required: true }"
          name="form-input-ftpUsername"
          :state="validateState('form-input-ftpUsername')"
          data-vv-as="SFTP Username"
          autocomplete="off"
        />
        <b-form-invalid-feedback id="form-input-ftpUsername-feedback">
          {{ veeErrors.first('form-input-ftpUsername') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="SFTP Password:">
        <b-form-input
          id="form-input-ftpPassword"
          v-model="storefront.ftpPassword"
          v-validate="{ required: true }"
          name="form-input-ftpPassword"
          :state="validateState('form-input-ftpPassword')"
          data-vv-as="SFTP Password"
          type="password"
          autocomplete="new-password"
        />
        <b-form-invalid-feedback id="form-input-ftpPassword-feedback">
          {{ veeErrors.first('form-input-ftpPassword') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="Import Path:">
        <b-form-input
          id="form-input-ftpImportPath"
          v-model="storefront.ftpImportPath"
          v-validate="{ required: false }"
          name="form-input-ftpImportPath"
          :state="validateState('form-input-ftpImportPath')"
          data-vv-as="Import Path"
          placeholder="/OrdersImport"
        />
        <b-form-invalid-feedback id="form-input-ftpImportPath-feedback">
          {{ veeErrors.first('form-input-ftpImportPath') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-6" label="Export Path:">
        <b-form-input
          id="form-input-ftpExportPath"
          v-model="storefront.ftpExportPath"
          v-validate="{ required: false }"
          name="form-input-ftpExportPath"
          :state="validateState('form-input-ftpExportPath')"
          data-vv-as="Export Path"
          placeholder="/ShipmentDetailsExport"
        />
        <b-form-invalid-feedback id="form-input-ftpExportPath-feedback">
          {{ veeErrors.first('form-input-ftpExportPath') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="col-12" label="Import Sheet Mapping Method:">
        <b-v-select
          v-model="storefront.ftpImportMappingMethodId"
          v-validate="{ required: false }"
          :searchable="true"
          name="form-input-ftpImportMappingMethodId"
          :state="validateState('form-input-ftpImportMappingMethodId')"
          data-vv-as="Import Mapping Method"
          :options="importSheetMappingMethodOptions"
        >
          <template v-slot:validationMsg>
            <b-form-invalid-feedback id="form-input-ftpImportMappingMethodId-feedback">
              {{ veeErrors.first('form-input-ftpImportMappingMethodId') }}
            </b-form-invalid-feedback>
          </template>
        </b-v-select>
      </b-form-group>
    </template>
  </div>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'StorefrontIntegrationSystemConfigCards',
  mixins: [myCommonDataMixin],
  props: {
    storefront: {
      type: Object,
      required: true
    },
    validateState: {
      required: true
    },
    isOrderSourceIntegration: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      brightPearlOrderStatuses: [],
      brightPearlOrderTypes: [],
      brightPearlWarehouses: [],
      brightPearlContacts: [],
      importSheetMappingMethods: []
    };
  },
  computed: {
    brightPearlOrderStatusOptions() {
      var opts = [{ value: null, text: '— No filter —' }];
      this.brightPearlOrderStatuses.forEach(function(s) {
        opts.push({ value: String(s.statusId), text: s.statusId + ' - ' + s.name + (s.orderTypeCode ? ' (' + s.orderTypeCode + ')' : '') });
      });
      return opts;
    },
    brightPearlOrderStatusMustHaveOptions() {
      return this.brightPearlOrderStatuses.map(function(s) {
        return { value: String(s.statusId), text: s.statusId + ' - ' + s.name + (s.orderTypeCode ? ' (' + s.orderTypeCode + ')' : '') };
      });
    },
    brightPearlWarehouseOptions() {
      return this.brightPearlWarehouses.map(function(w) {
        return { value: String(w.id), text: w.id + ' - ' + w.name + (w.typeDescription ? ' (' + w.typeDescription + ')' : '') };
      });
    },
    brightPearlOrderTypeOptions() {
      var opts = [{ value: null, text: '— No filter —' }];
      this.brightPearlOrderTypes.forEach(function(t) {
        opts.push({ value: String(t.id), text: t.id + ' - ' + t.description + ' (' + t.code + ')' });
      });
      return opts;
    },
    brightPearlContactOptions() {
      return this.brightPearlContacts.map(function(c) {
        var parts = [];
        if (c.companyName) parts.push('['+c.companyName+']');
        if (c.firstName || c.lastName) parts.push([c.firstName, c.lastName].filter(Boolean).join(' '));
        if (c.email) parts.push('('+c.email+')');
        return { value: String(c.id), text: parts.join(' ') };
      });
    },
    importSheetMappingMethodOptions() {
      var opts = [{ value: null, text: '— Default column mapping —' }];
      this.importSheetMappingMethods.forEach(function(m) {
        opts.push({ value: m.id, text: m.name });
      });
      return opts;
    }
  },
  created() {
    if (this.storefront && this.storefront.integrationSystem === 'BrightPearl' && this.storefront.integrationValid) {
      this.LoadBrightPearlOrderStatuses();
      this.LoadBrightPearlOrderTypes();
      this.LoadBrightPearlWarehouses();
      this.LoadBrightPearlContacts();
    }
    this.LoadImportSheetMappingMethods();
  },
  watch: {
    'storefront.integrationValid': function(newVal) {
      if (newVal && this.storefront.integrationSystem === 'BrightPearl') {
        this.LoadBrightPearlOrderStatuses();
        this.LoadBrightPearlOrderTypes();
        this.LoadBrightPearlWarehouses();
        this.LoadBrightPearlContacts();
      }
    }
  },
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.$bvToast.toast('Storefront ID copied to clipboard', {
              title: 'Success',
              variant: 'success',
              solid: true,
              autoHideDelay: 2000
            });
          })
          .catch((err) => {
            console.error('Failed to copy:', err);
          });
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          this.$bvToast.toast('Storefront ID copied to clipboard', {
            title: 'Success',
            variant: 'success',
            solid: true,
            autoHideDelay: 2000
          });
        } catch (err) {
          console.error('Failed to copy:', err);
        }
        document.body.removeChild(textarea);
      }
    },
    RemoveAuthWithShopify() {
      this.$http.post('/api/storefronts/integrations/shopify/deauthorize_store', {
        storefrontId: this.id
      })
      .then((resp) =>{
        this.ResetForm();
        this.LoadItem(this.id);
      })
      .catch((err) => {
        console.log(err);
      });
    },
    AuthWithBrightPearl() {
      var self = this;
      var payload = self.isOrderSourceIntegration
        ? { orderSourceIntegrationId: self.storefront.id, brightPearlAccountId: self.storefront.brightPearlAccountId }
        : { storefrontId: self.storefront.id, brightPearlAccountId: self.storefront.brightPearlAccountId };
      self.$http.post('/api/integrations/brightpearl/authorize_store', payload)
      .then(function(resp) {
        if (resp.data && resp.data.authUrl) {
          if (self.isOrderSourceIntegration) {
            localStorage.setItem('BRIGHTPEARL_OSI_CON_ID', self.storefront.id);
          } else {
            localStorage.setItem('BRIGHTPEARL_STOREFRONT_CON_ID', self.storefront.id);
          }
          window.location.href = resp.data.authUrl;
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    RemoveAuthWithBrightPearl() {
      var self = this;
      var payload = self.isOrderSourceIntegration
        ? { orderSourceIntegrationId: self.storefront.id }
        : { storefrontId: self.storefront.id };
      self.$http.post('/api/integrations/brightpearl/deauthorize_store', payload)
      .then(function() {
        self.brightPearlOrderStatuses = [];
        self.brightPearlOrderTypes = [];
        self.brightPearlWarehouses = [];
        if (self.isOrderSourceIntegration) {
          self.$emit('reload');
        } else {
          self.ResetForm();
          self.LoadItem(self.storefront.id);
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    LoadBrightPearlOrderStatuses() {
      var self = this;
      var payload = self.isOrderSourceIntegration
        ? { orderSourceIntegrationId: self.storefront.id }
        : { storefrontId: self.storefront.id };
      self.$http.post('/api/integrations/brightpearl/order-statuses', payload)
      .then(function(resp) {
        if (resp.data && resp.data.statuses) {
          self.brightPearlOrderStatuses = resp.data.statuses;
        }
      })
      .catch(function(err) {
        console.log('Failed to load BrightPearl order statuses', err);
      });
    },
    LoadBrightPearlOrderTypes() {
      var self = this;
      var payload = self.isOrderSourceIntegration
        ? { orderSourceIntegrationId: self.storefront.id }
        : { storefrontId: self.storefront.id };
      self.$http.post('/api/integrations/brightpearl/order-types', payload)
      .then(function(resp) {
        if (resp.data && resp.data.types) {
          self.brightPearlOrderTypes = resp.data.types;
        }
      })
      .catch(function(err) {
        console.log('Failed to load BrightPearl order types', err);
      });
    },
    LoadBrightPearlWarehouses() {
      var self = this;
      var payload = self.isOrderSourceIntegration
        ? { orderSourceIntegrationId: self.storefront.id }
        : { storefrontId: self.storefront.id };
      self.$http.post('/api/integrations/brightpearl/warehouses', payload)
      .then(function(resp) {
        if (resp.data && resp.data.warehouses) {
          self.brightPearlWarehouses = resp.data.warehouses;
        }
      })
      .catch(function(err) {
        console.log('Failed to load BrightPearl warehouses', err);
      });
    },
    LoadBrightPearlContacts() {
      var self = this;
      var payload = self.isOrderSourceIntegration
        ? { orderSourceIntegrationId: self.storefront.id }
        : { storefrontId: self.storefront.id };
      self.$http.post('/api/integrations/brightpearl/contacts', payload)
      .then(function(resp) {
        if (resp.data && resp.data.contacts) {
          self.brightPearlContacts = resp.data.contacts;
        }
      })
      .catch(function(err) {
        console.log('Failed to load BrightPearl contacts', err);
      });
    },
    AuthWithShopify() {
      this.$http.post('/api/storefronts/integrations/shopify/authorize_store', {
        storefrontId: this.storefront.id,
        shopifyStoreDomain: this.storefront.shopifyStoreDomain
      })
      .then((resp) =>{
        if(resp.data.authUrl) {
          localStorage.setItem('SHOPIFY_STOREFRONT_CON_ID', this.storefront.id);
          window.location.href = resp.data.authUrl;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
    LoadImportSheetMappingMethods() {
      var self = this;
      self.$http.post('/api/common/import-sheet-mapping-methods/listItems', {
        page: 1,
        perPage: 500,
        type: 'StorefrontOrderImport'
      })
      .then(function(response) {
        if (response.data && response.data.total && response.data.items) {
          self.importSheetMappingMethods = response.data.items;
        } else {
          self.importSheetMappingMethods = [];
        }
      })
      .catch(function(err) {
        console.error('Failed to load import sheet mapping methods', err);
        self.importSheetMappingMethods = [];
      });
    }
  }
};
</script>